import React from "react";
import { RouteProps } from "react-router-dom";
import withValidUserRole, { withValidUserRoleProps } from "../Auth/ProtectedPage";
import ProviderProfilePage from "./ProviderProfilePage";

interface ProviderProfilePageContainerProps extends RouteProps, withValidUserRoleProps {}

const ProviderProfilePageContainer = (props: ProviderProfilePageContainerProps) => {
    const getTitle = () => {
        const path = props.location ? props.location.pathname : "";
        return path === "/" ? "Templates" : `${path.charAt(1).toUpperCase()}${path.slice(2)}`;
    };

    const getType = () => {
        const path = props.location ? props.location.pathname : "";
        return path === "/" ? "templates" : getTitle().toLowerCase();
    };

    return <ProviderProfilePage title={getTitle()} category={getType()} />;
};

export default withValidUserRole(ProviderProfilePageContainer);
